import { httpClient } from './httpClient';

export const fetchCampaigns = async (companyId) => {
  const response = await httpClient.get(`/campaigns/${companyId}`);
  return response.data;
};

export const updateCampaignStatus = async (campaignId, isActive) => {
  const response = await httpClient.put(`/campaigns/${campaignId}/status`, {
    is_active: isActive,
  });
  return response.data;
};

export const createCampaign = async (
  companyId,
  campaignCode,
  planName,
  priceId,
  planType,
  upgradePlanId,
  upgradeType,
  usageDays,
  exclusivePlan
) => {
  const response = await httpClient.post(`/campaigns/store`, {
    company_id: companyId,
    campaign_code: campaignCode,
    plan_name: planName,
    price_id: priceId,
    planType: planType,
    upgrade_plan_id: upgradePlanId || null,
    upgradeType,
    usage_days: usageDays ?? null,
    exclusive_plan: exclusivePlan,
  });
  return response.data;
};

export const checkCampaignActive = async (priceId) => {
  const response = await httpClient.get(`/campaigns/check-active`, {
    params: { price_id: priceId },
  });
  return response.data;
};
export const checkCampaignCode = async (exclusive_plan) => {
  if (!exclusive_plan) return { exists: false };

  const response = await httpClient.get('/campaigns/check-exclusive', {
    params: { exclusive_plan: exclusive_plan },
  });

  return response.data;
};
